import * as React from "react";
import { geoStatus } from "common/hooks/useGeolocation";
import FirstScreen from "./FirstScreen";
import SecondScreen from "./SecondScreen";
import styles from "./styles.module.scss";

const Root = ({ isFirstScreen, setIsFirstScreen }) => {
  const cords = localStorage.getItem("cords");

  React.useEffect(() => {
    if (!cords) return setIsFirstScreen(true);
    if (geoStatus[cords]) return setIsFirstScreen(false);
    return setIsFirstScreen(false);
  }, [cords]);

  return (
    <div className={styles.root}>
      {isFirstScreen && <FirstScreen setIsFirstScreen={setIsFirstScreen} />}
      {!isFirstScreen && <SecondScreen />}
    </div>
  );
};

export default Root;
